package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class AccountUnsubscribeInfo(
    val reCaptchaToken: String,
    val email: String
)

@Serializable
data class AccountUnsubscribeSDKInfo(
    val reCaptchaToken: String? = null,
    val messageToken: String? = null,
    val email: String
)